import styled from 'styled-components';

export const Wrapper = styled.div.attrs({
  className: 'col-md mb-3 mb-md-auto',
})``;
